<template>
    <div v-if="showUpload">
        <vxe-form
            :data="packageForm"
            :rules="packageForm.formRules"
            ref="rForm"
        >
            <vxe-form-item
                title="程序包"
                field="packageName"
                span="16"
                :item-render="{}"
                title-width="100px"
            >
                <template #default>
                    <vxe-input
                        v-model="packageForm.packageName"
                        placeholder="请选择程序包"
                        readonly
                    ></vxe-input>
                </template>
            </vxe-form-item>
            <vxe-form-item title="" span="2" :item-render="{}">
                <template #default="">
                    <vxe-button
                        :disabled="packageForm.isDisable"
                        @click="insertUpdatePackageEvent"
                    >
                        浏览
                    </vxe-button>
                </template>
            </vxe-form-item>
            <vxe-form-item title="" span="6" :item-render="{}">
                <span style="color: red; margin-left: 10px"></span>
            </vxe-form-item>
            <vxe-form-item
                title="说明文档"
                field="pddName"
                span="16"
                :item-render="{}"
                title-width="100px"
            >
                <template #default>
                    <vxe-input
                        v-model="packageForm.pddName"
                        placeholder="请选择说明文档"
                        readonly
                    ></vxe-input>
                </template>
            </vxe-form-item>
            <vxe-form-item title="" span="2" :item-render="{}">
                <template #default="">
                    <vxe-button
                        :disabled="packageForm.isDisable"
                        @click="insertUpdatePddEvent"
                    >
                        浏览
                    </vxe-button>
                </template>
            </vxe-form-item>
            <vxe-form-item title="" span="6" :item-render="{}">
                <span style="color: red; margin-left: 10px"></span>
            </vxe-form-item>
            <vxe-form-item
                title="版本说明"
                field="description"
                span="18"
                :item-render="{}"
                title-width="100px"
            >
                <template #default>
                    <vxe-input
                        v-model="packageForm.description"
                        placeholder="请输入版本说明"
                    ></vxe-input>
                </template>
            </vxe-form-item>
            <vxe-form-item title="" span="6" :item-render="{}">
                <vxe-button
                    status="primary"
                    :disabled="packageForm.isDisable"
                    @click="uploadVersion"
                >
                    提交新版本
                </vxe-button>
            </vxe-form-item>
        </vxe-form>
    </div>
    <div>
        <vxe-table
            class="mytable-scrollbar"
            :data="packageForm.dtPackage"
            ref="xTableUser"
            height="250"
            highlight-hover-row
            highlight-current-row
        >
            <vxe-column
                type="seq"
                field="Id"
                title="序号"
                width="50"
            ></vxe-column>
            <vxe-column
                field="VersionCode"
                title="版本号"
                width="100"
                sortable
            ></vxe-column>
            <vxe-column
                field="ApplyTime"
                title="更新日期"
                width="140"
                sortable
                resizable
                :formatter="formatDate"
            ></vxe-column>
            <vxe-column
                field="Description"
                title="版本说明"
                width="160"
                sortable
                show-overflow
            ></vxe-column>
            <vxe-column title="程序包" width="100" align="center">
                <template #default="{ row }">
                    <vxe-button
                        type="text"
                        @click="downloadFile(row, '1')"
                        class="blue-text"
                        >下载</vxe-button
                    >
                </template></vxe-column
            >
            <vxe-column align="center" title="说明文档" width="100">
                <template #default="{ row }">
                    <vxe-button
                        type="text"
                        @click="downloadFile(row, '2')"
                        class="blue-text"
                        >下载</vxe-button
                    >
                </template>
            </vxe-column>
            <vxe-column
                align="center"
                title="在线安装"
                width="100"
                v-if="false"
            >
                <template #default="{ row }">
                    <vxe-button
                        type="text"
                        @click="installPackage(row)"
                        class="blue-text"
                        >安装</vxe-button
                    >
                </template>
            </vxe-column>
        </vxe-table>
    </div>
    <div>
        <vxe-pager
            background
            v-model:current-page="updatePackagePager.currentPage"
            v-model:page-size="updatePackagePager.pageSize"
            :total="updatePackagePager.totalResult"
            @page-change="updatePackageListPageChange"
            size="small"
        >
        </vxe-pager>
    </div>
</template>

<script setup>
import {
    ref,
    onMounted,
    getCurrentInstance,
    defineExpose,
    defineProps,
    reactive,
} from "vue";

import Qs from "qs";
import { VXETable } from "vxe-table";
const rForm = ref(null);
const { proxy } = getCurrentInstance();
const props = defineProps({
    appId: {
        // 查询类型
        type: String,
        default: "",
    },
    isShowUpload: {
        type: Boolean,
        default: true,
    },
});
const showUpload = ref(props.isShowUpload);
const updatePackagePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});
const packageForm = reactive({
    dtPackage: [],
    iShow: false, //显示更新包
    packageFile: {}, //更新包附件
    packageName: "",
    pddFile: {}, //说明文档
    pddName: "",
    description: "", //版本说明
    appId: props.appId, //更新的ID
    creatorUID: "",
    isDisable: false,
    formRules: {
        packageName: [{ required: true, message: "程序包不能为空" }],
        description: [{ required: true, message: "版本说明不能为空" }],
    },
});
const formInput = reactive({
    formData: {
        Id: "",
        status: "0",
        appName: "名称",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "",
        creatorUID: "",
        CreateMan: "",
        creationTime: "",
        appClassId: "",
        labelId: "",
        fPathPackage: "",
    },
});

const loadData = (appId) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [appId],
    };
    proxy.$api.componentManageAPI
        .getComponentOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            //如果不存在则返回
            if (res.data.Message == "None") {
                return;
            }
            formInput.formData = res.data.Data;
        })
        .catch((error) => {
            console.log(error);
        });
};
//上传发布包
const insertUpdatePackageEvent = async () => {
    const { files } = await VXETable.readFile(false);

    Array.from(files).map((file) => {
        packageForm.packageName = file.name;
        packageForm.packageFile = file;
    });

    let suffix = packageForm.packageName
        .toString()
        .substring(packageForm.packageName.toString().lastIndexOf(".") + 1);

    if (suffix.toLowerCase() !== "rar") {
        VXETable.modal.alert({
            content: "程序包类型不正确，应为rar",
            status: "error",
        });
        packageForm.packageName = "";
        packageForm.packageFile = {};
        return;
    }
};
const insertUpdatePddEvent = async () => {
    const { files } = await VXETable.readFile(false);

    Array.from(files).map((file) => {
        packageForm.pddName = file.name;
        packageForm.pddFile = file;
    });
};
const findPackageData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: updatePackagePager.currentPage,
        pageSize: updatePackagePager.pageSize,
        searchKey: [packageForm.appId],
    };
    proxy.$api.componentManageAPI
        .getPackageList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            packageForm.dtPackage = res.data.Data.dataTable;
            updatePackagePager.currentPage = res.data.Data.currentPage;
            updatePackagePager.pageSize = res.data.Data.pageSize;
            updatePackagePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const formatDate = ({ cellValue }) => {
    if (!cellValue) {
        return "";
    }
    const date = new Date(cellValue);
    if (isNaN(date)) {
        return cellValue;
    } // 避免无效时间报错
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${y}-${m}-${d} ${hh}:${mm}`;
};
const uploadVersion = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    const params = new FormData();

    params.append("appId", packageForm.appId);
    params.append("package", packageForm.packageFile);
    params.append("packageName", packageForm.packageName);
    params.append("pdd", packageForm.pddFile);
    params.append("pddName", packageForm.pddName);
    params.append("description", packageForm.description);
    params.append("creatorUID", proxy.$store.state.userID);

    proxy.$api.componentManageAPI
        .updateAppVersion(params)
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            VXETable.modal.message({
                content: "上传成功，请30秒后再调用MCP",
                status: "success",
            });
            packageForm.packageFile = {};
            packageForm.packageName = "";
            packageForm.pddFile = {};
            packageForm.pddName = "";
            packageForm.description = "";

            findPackageData();
        })
        .catch((error) => {
            console.log(error);
        });
};

const downloadFile = (row, type) => {
    proxy.$api.fileManageAPI
        .downloadComponentFile(
            Qs.stringify({
                appId: row.app_id,
                type: type,
                VersionCode: row.VersionCode,
            })
        )
        .then(async (res) => {
            const contentType = res.headers["content-type"] || "";

            // 后端返回错误 JSON
            if (contentType.includes("application/json")) {
                const text = await res.data.text();

                try {
                    const result = JSON.parse(text);

                    VXETable.modal.alert({
                        content: result.Message || result.message || "下载失败",
                        status: "error",
                    });
                } catch {
                    VXETable.modal.alert({
                        content: text || "下载失败",
                        status: "error",
                    });
                }

                return;
            }

            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );
                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            if (!blob || blob.size === 0) {
                VXETable.modal.alert({
                    content: "下载失败：文件内容为空",
                    status: "error",
                });
                return;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};
onMounted(() => {
    loadData(props.appId);
    findPackageData();
});
</script>

<style scoped>
.blue-text {
    color: #1677ff !important; /* 蓝色 */
    font-weight: 500; /* 稍微加粗，好看一点 */
    cursor: pointer; /* 鼠标移上去是小手 */
}
.blue-text:hover {
    text-decoration: underline; /* 悬停时加下划线 */
}
</style>
